import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import {
  FlexCenterWrapper, WhiteSpaceNoWrap, Mr3, FitRelativeWrapper, AbsoluteLeftTopWrapper,
  CustomBorderWrapper, Py2, CustomHeight, FullWIdthColumnScrollWrapper, My1, FlexBoxWrapper,
  FlexCenterJustifyCenterWrapper, GenericWrapper, CursorPointerWrapper
} from 'wrappers';
import internalState from './internalState';
import { SecondaryTextSm, Icon, SecondaryTextSmBold, SearchInput } from 'atoms';
import { DownCaretSvg } from 'components/icons';
import { TextButton, DropdownRow } from 'molecules';
import { escapedRegex } from 'utils';
import { textEllipsis } from 'utils/ellipsis';

export const definition = {
  name: 'FilterDropdown',
  controller: Controller,
  initialProps: ({ options, selectedOptionId, isReadonly, placeholder, width, hasSearch, pageSize, headerMaxLength, hideCaret }) =>
    ({ options, selectedOptionId, isReadonly, placeholder, width, hasSearch, pageSize, headerMaxLength, hideCaret }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'Header',
          isButton: true,
          bindings: ({ isOpen, isReadonly, selectedOptionId, containerRef, inputRef }) => ({ isOpen, containerRef, isReadonly, inputRef, selectedOptionId }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSmBold, WhiteSpaceNoWrap), Mr3),
              name: 'Title',
              renderIf: ({ selectedOptionId }) => !!selectedOptionId,
              displayValue: ({ selectedOptionId, options, headerMaxLength }) => {
                let option = options.find(o => o.id === selectedOptionId)
                return headerMaxLength ? textEllipsis(option?.displayName ?? '', headerMaxLength) : option?.displayName ?? '';
              }
            },
            {
              component: wrap(wrap(SecondaryTextSm, WhiteSpaceNoWrap), Mr3),
              name: 'Placeholder',
              renderIf: ({ selectedOptionId }) => !selectedOptionId,
              displayValue: ({ placeholder }) => {
                return placeholder ?? 'Please select';
              }
            },
            {
              component: Icon,
              name: 'Icon',
              renderIf: ({ hideCaret }) => !hideCaret,
              displayValue: ({ isOpen }) => DownCaretSvg({ color: window?.settings?.secondary_color ?? '#04333B', up: isOpen })
            }
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '24px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: GenericWrapper,
              name: 'InputWrapper',
              ref: ({ inputRef }) => inputRef ?? null,
              elements: [
                {
                  component: SearchInput,
                  name: "Input",
                  renderIf: ({ hasSearch }) => hasSearch,
                  bindings: ({ searchTerm }) => ({ label: '', value: searchTerm, placeholder: 'Search' })
                },
              ]
            },
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ hasSearch }) => ({ borderRadius: hasSearch ? '0px 0px 8px 8px' : '8px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: CustomHeight,
                  name: 'ListWrapper',
                  displayState: ({ width }) => ({ maxHeight: 160, width: width ?? '300px', display: 'flex' }),
                  elements: [
                    {
                      wrapper: FullWIdthColumnScrollWrapper,
                      displayState: ({ }) => ({ flexGrow: 1, height: 'unset' }),
                      name: 'ListWrapper',
                      elements: [
                        {
                          component: wrap(DropdownRow, My1),
                          name: 'Option',
                          isListOf: { option: ({ options, pageNumber, searchTerm, pageSize }) => options.filter(o => escapedRegex(searchTerm).test(o.displayName)).slice(0, pageNumber * (pageSize ?? 10)) },
                          bindings: ({ option, selectedOptionId }) => ({
                            icon: option.icon, image: option.image, id: option.id, isSelected: selectedOptionId === option.id, text: option.displayName
                          }),
                          displayState: ({ option, selectedOptionId }) => ({ isSelected: selectedOptionId === option.id })
                        },
                        {
                          component: wrap(wrap(wrap(TextButton, FlexBoxWrapper), FlexCenterJustifyCenterWrapper), Py2),
                          name: 'LoadMore',
                          renderIf: ({ options, pageNumber, searchTerm, pageSize }) => (pageNumber * (pageSize ?? 10)) < options.filter(o => escapedRegex(searchTerm).test(o.displayName)).length,
                          bindings: ({ pageNumber }) => ({ title: 'Load More...', pageNumber })
                        }
                      ]
                    },
                  ]
                }
              ]
            }
          ]
        }

      ]
    }
  ]
};

export default ContainerComponent(definition)